import React, { useEffect, useState } from "react";
import LinksComponent from "../../../components/Tenant/LinksComponent/LinksComponent";
import { useFetchAllCheckinQrCodeWithoutGenerationMutation } from "../../../features/tenant/qrCode/qrCodeApi";
import { useGetSupplyBeamSiteLocationsMutation } from "../../../features/supplyBeam/siteLocationsSB/siteLocationSBApi";
import DataTableComponent from "../../../components/Tenant/DataTableComponent/DataTableComponent";
import { useNavigate } from "react-router-dom";
import ViewQr from "../../../components/Tenant/ViewQR/ViewQr";
import { toast } from "react-hot-toast";

function objectsAreEqual(obj1, obj2) {
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);
    if (keys1.length !== keys2.length) return false;
    for (let key of keys1) {
        if (!obj2.hasOwnProperty(key)) return false;
        if (obj1[key] !== obj2[key]) return false;
    }
    return true;
}

const AllCheckInQrList = () => {
    const navigate = useNavigate();
    const initialRequest = {
        product_code: "",
        batch_running_code: "",
        user_name: "",
        limit: 10,
        offset: 0,
        startDate: "",
        endDate: "",
        location_id: "",
    };
    const initialRequestCount = {
        product_code: "",
        batch_running_code: "",
        user_name: "",
        startDate: "",
        endDate: "",
        location_id: "",
    };

    const [request, setRequest] = useState(initialRequest);
    const [myList, setMyList] = useState([]);
    const [totalRows, setTotalRows] = useState(0);
    const [requestCount, setRequestCount] = useState(initialRequestCount);
    const [limit, setLimit] = useState(10);
    const [offset, setOffset] = useState(0);
    const [showQr, setShowQr] = useState(false);
    const [qrData, setQrData] = useState(null);
    const [locations, setLocations] = useState([]);

    const [fetchLocations] = useGetSupplyBeamSiteLocationsMutation();

    useEffect(() => {
        const loadLocations = async () => {
            try {
                const response = await fetchLocations({
                    token: sessionStorage.getItem("access_token"),
                    tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
                    body: {},
                }).unwrap();
                if (response && response.body && response.body.data) {
                    setLocations(response.body.data);
                }
            } catch (err) {
                console.error("Failed to fetch locations", err);
            }
        };
        loadLocations();
    }, []);

    const [
        fetchCheckinQrs,
        { isLoading: isFetching }
    ] = useFetchAllCheckinQrCodeWithoutGenerationMutation();

    const clearFilters = () => {
        setRequest(initialRequest);
        setOffset(0);
        setLimit(10);
    };

    const columns = [
        {
            name: "SNo",
            cell: (row, idx) => offset + Number(idx + 1),
            width: "80px",
        },
        {
            name: "Reference Number",
            selector: (row) => row.checkin_ref || "N/A",
            sortable: true,
            width: "150px",
        },
        {
            name: "Batch Running Code",
            selector: (row) => row.batch_running_code || "N/A",
            sortable: true,
            width: "150px",
        },
        {
            name: "Product Code",
            selector: (row) => row.product_code || "N/A",
            sortable: true,
            width: "130px",
        },
        {
            name: "Qr Code",
            selector: (row) => row.unique_code || "N/A",
            sortable: true,
            width: "150px",
        },
        {
            name: "Scratch Code",
            selector: (row) => row.scratch_code || "N/A",
            sortable: true,
            width: "130px",
        },
        {
            name: "User Name",
            selector: (row) => row.user_name || "N/A",
            sortable: true,
            width: "150px",
        },
        {
            name: "User Mobile",
            selector: (row) => row.user_mobile || "N/A",
            sortable: true,
            width: "130px",
        },
        {
            name: "Checkin Date",
            selector: (row) => new Date(row.created_at).toLocaleString(),
            sortable: true,
            width: "180px",
        },
        {
            name: "Actions",
            cell: (row) => (
                <button
                    className="bg-primary text-white px-3 py-1 rounded text-xs uppercase font-medium hover:bg-primary-dark transition shadow-md"
                    onClick={() => handleShowQr(row)}
                >
                    View QR
                </button>
            ),
            width: "120px",
        },
    ];

    const fetchAllQrCodeFunction = async () => {
        try {
            const response = await fetchCheckinQrs({
                token: sessionStorage.getItem("access_token"),
                tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
                body: request,
            }).unwrap();

            if (response && response.body) {
                setMyList(response.body.qrsList || []);
                setTotalRows(response.body.total_qr || 0);
            }
        } catch (err) {
            toast.error("Failed to fetch checkin QRs");
            console.error(err);
        }
    };

    useEffect(() => {
        fetchAllQrCodeFunction();
    }, [request]);

    const handleShowQr = (data) => {
        let obj = {
            link: data.unique_code.includes("gverify.me")
                ? data.unique_code
                : `http://gverify.me/?${data.unique_code}`,
            ...data,
        };
        setQrData(obj);
        setShowQr(true);
    };

    const handlePageChange = (pageNumber) => {
        const newOffset = (pageNumber - 1) * limit;
        setOffset(newOffset);
        setRequest({ ...request, offset: newOffset });
    };

    const handlePerRowsChange = (newPerPage) => {
        setLimit(newPerPage);
        setRequest({ ...request, limit: newPerPage, offset: 0 });
        setOffset(0);
    };

    return (
        <div className="flex w-full bg-gray-100 min-h-screen justify-center">
            <div className="w-full">
                <div className="border-b bg-white border-gray-300 pl-6 py-4 shadow-sm text-2xl font-bold flex justify-between items-center px-6">
                    <span>All Checkin QRs List</span>
                    <LinksComponent />
                </div>

                <div className="p-6">
                    <div className="bg-white shadow-xl rounded-xl overflow-hidden border border-gray-200">
                        <div className="bg-gray-50 p-6 border-b border-gray-200">
                            <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-6 gap-4">
                                <div>
                                    <label className="block text-sm font-semibold text-gray-700 mb-1">Batch Code</label>
                                    <input
                                        type="text"
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent outline-none transition-all"
                                        placeholder="Batch Code"
                                        value={request.batch_running_code}
                                        onChange={(e) => setRequest({ ...request, batch_running_code: e.target.value, offset: 0 })}
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm font-semibold text-gray-700 mb-1">Product Code</label>
                                    <input
                                        type="text"
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent outline-none transition-all"
                                        placeholder="Product Code"
                                        value={request.product_code}
                                        onChange={(e) => setRequest({ ...request, product_code: e.target.value, offset: 0 })}
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm font-semibold text-gray-700 mb-1">User Name</label>
                                    <input
                                        type="text"
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent outline-none transition-all"
                                        placeholder="User Name"
                                        value={request.user_name}
                                        onChange={(e) => setRequest({ ...request, user_name: e.target.value, offset: 0 })}
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm font-semibold text-gray-700 mb-1">Start Date</label>
                                    <input
                                        type="date"
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent outline-none transition-all"
                                        value={request.startDate}
                                        onChange={(e) => setRequest({ ...request, startDate: e.target.value, offset: 0 })}
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm font-semibold text-gray-700 mb-1">End Date</label>
                                    <input
                                        type="date"
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent outline-none transition-all"
                                        value={request.endDate}
                                        onChange={(e) => setRequest({ ...request, endDate: e.target.value, offset: 0 })}
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm font-semibold text-gray-700 mb-1">Location</label>
                                    <select
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent outline-none transition-all"
                                        value={request.location_id}
                                        onChange={(e) => setRequest({ ...request, location_id: e.target.value, offset: 0 })}
                                    >
                                        <option value="">All Locations</option>
                                        {locations.map((loc) => (
                                            <option key={loc.id} value={loc.location_code}>
                                                {loc.location}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="flex items-end gap-2">
                                    <button
                                        className="flex-1 bg-primary text-white px-4 py-2 rounded-lg font-semibold hover:bg-primary-dark transition shadow-md"
                                        onClick={fetchAllQrCodeFunction}
                                    >
                                        Search
                                    </button>
                                    <button
                                        className="flex-1 bg-gray-200 text-gray-700 px-4 py-2 rounded-lg font-semibold hover:bg-gray-300 transition"
                                        onClick={clearFilters}
                                    >
                                        Clear
                                    </button>
                                </div>
                            </div>
                        </div>

                        <DataTableComponent
                            columns={columns}
                            data={myList}
                            loading={isFetching}
                            totalRows={totalRows}
                            handlePerRowsChange={handlePerRowsChange}
                            handlePageChange={handlePageChange}
                            paginationPerPage={limit}
                        />
                    </div>
                </div>
            </div>
            {showQr && <ViewQr data={qrData} show={showQr} setShow={setShowQr} />}
        </div>
    );
};

export default AllCheckInQrList;